export default {"src":"https://images-cdn.curipod.com/d-6e17e97e/_next/static/media/rocket.9360f2a3.svg","height":199,"width":200};